module.exports = [{
      plugin: require('/Users/beth/frontends/bethsdad/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/beth/frontends/bethsdad/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    },{
      plugin: require('/Users/beth/frontends/bethsdad/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
